import {
  DurationFilter,
  ActivitiesPageFilters,
} from "domain/entities/activities.entities";
import {
  CreateTechnique,
  TechniquesFilters,
  UpdateSequences,
} from "domain/entities/techniques.entities";
import { createAppAsyncThunk } from "domain/store.thunk";

export const getTechniques = createAppAsyncThunk(
  "techniques/getTechniques",
  async (
    filters: TechniquesFilters &
      Partial<ActivitiesPageFilters> &
      Partial<{ duration: DurationFilter; search: string }>,
    { extra: { techniquesGateway } }
  ) => {
    return await techniquesGateway.getTechniques(filters);
  }
);

export const getTechnique = createAppAsyncThunk(
  "techniques/getTechnique",
  async (
    { id, consignes }: { id: number; consignes?: boolean },
    { extra: { techniquesGateway } }
  ) => {
    return await techniquesGateway.getTechnique({ id, consignes });
  }
);

export const getTechniqueAdvice = createAppAsyncThunk(
  "techniques/getTechniqueAdvice",
  async (id: number, { extra: { techniquesGateway } }) => {
    return await techniquesGateway.getTechniqueAdvice(id);
  }
);

export const getFavoritesTechniques = createAppAsyncThunk(
  "techniques/getFavoritesTechniques",
  async (techniqueIds: number[], { extra: { techniquesGateway } }) => {
    return await techniquesGateway.getFavoritesTechniques(techniqueIds);
  }
);

export const getPauses = createAppAsyncThunk(
  "techniques/getPauses",
  async (_, { extra: { techniquesGateway } }) => {
    return await techniquesGateway.getTechniques({
      types: ["pause"],
      "$sort[duration]": 1,
    });
  }
);

export const setIsTechniqueLoading = createAppAsyncThunk(
  "techniques/setIsTechniqueLoading",
  async (isLoading: boolean, { extra: { techniquesGateway } }) => {
    return { isLoading };
  }
);

export const createTechnique = createAppAsyncThunk(
  "techniques/createTechnique",
  async (technique: CreateTechnique, { extra: { techniquesGateway } }) => {
    return await techniquesGateway.createTechnique(technique);
  }
);

export const updateSequences = createAppAsyncThunk(
  "techniques/updateSequences",
  async (body: UpdateSequences, { extra: { techniquesGateway } }) => {
    return await techniquesGateway.updateSequences(body);
  }
);

export const getRandomTechnique = createAppAsyncThunk(
  "techniques/getRandomTechnique",
  async (_, { extra: { techniquesGateway } }) => {
    return await techniquesGateway.getRandomTechnique();
  }
);
